import BaseSelect from "@/views/crud/modules/BaseSelect.vue";
import SelectionFrom from "@/components/modules/SelectionFrom.vue";

export default {
    key: "bay_reservation_config",
    id: "id",
    export: ["excel"],
    sort: {
        field: "bayId",
        order: "desc"
    },
    filters:{
        bayId: {},
        locId:{
            type: "select"
        },
    },
    options:{
        cpConnector:{
            key: "vw_cp_connector",
            label: "cpConnectorName",
            value: "cpConnectorId"
        },
        locId: {
            key: "cp_locs",
            label: "address",
            value: "loc_id"
        },
    },
    fields:[
        {key: "id", width: 50},
        {key: "bayId", disabled: ["edit"], width: "25%"},
        {key: "locId",  component:BaseSelect, type:"componentColumn", optionKey: "cp_locs",
            setup:{label:'label',value:'value'},
            hidden:["edit"]
        },
        //cpConnector for edit view
        {key: "cpConnector", disabled: ["edit"], hidden:["list"], type: "select"},
        //cpConnector for list view
        {key: "cpConnector",  hidden:["edit"], width: "50%", component:BaseSelect,  type:"componentColumn", optionKey: "vw_cp_connector", setup:{label:'label',value:'value'}},
        {key: "isReservation", type: "boolean", width: "10%"},
        {key: "action_button", type: "action-btn", width: 50},
    ],
    structure:[
        ["bayId"],["cpConnector"],
        ["isReservation"]
    ],
    action: ["edit"],

}